import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { LightTheme } from "../ThemeLight";

import { styles } from "./SocialLinks.style";
import { IUserSocials } from "../../backend/cloud/UserTable";
import { litIf } from "../LitUtils";

const SocialTypes = ["facebook", "instagram", "blueSky", "x", "website"];

function makeSocialLink(name: string, user: string) {
    switch (name) {
        case "facebook":
            return `https://www.facebook.com/${user}`;
        case "x":
            return `https://www.x.com/${user}`;
        case "blueSky":
            return `https://bsky.app/profile/${user}`;
        case "instagram":
            return `https://www.instagram.com/${user}`;
        case "website":
            return `${user}`;
    }
    return undefined;
}

@customElement("ds-social-links")
export class SocialLinks extends BaseElement {
    static override styles = [styles, LightTheme];

    @property({ type: Object }) socials?: IUserSocials;
    @property({ type: String }) direction: "row" | "column" = "row";

    private _renderSocial(name: string, user: string) {
        if (user) {
            const link = makeSocialLink(name, user);
            if (link) {
                return html`<div class="flex-row entry ${this.direction}">
                    <a class="social-link" target="_blank" href=${link}
                        ><sl-icon library="social" name=${name}></sl-icon>
                    </a>
                    ${this.direction === "column"
                        ? html`<a class="anchor" target="_blank" href=${link}>${link}</a>`
                        : ""}
                </div>`;
            }
        }
        return html``;
    }

    override render() {
        return litIf(
            this.socials,
            () =>
                html` <div class="container ${this.direction}">
                    ${SocialTypes.filter(
                        (x) => this.socials && Object.hasOwn(this.socials as object, x)
                    ).map((x) => this._renderSocial(x, (this.socials as any)[x]))}
                </div>`
        );
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-social-links": SocialLinks;
    }
}
